import React from "react"
import { Grid } from "@mui/material"
import {
	CheckinWeekdayField,
	DaysToMonitorField,
	PickupDatesSubSection,
	RentalLengthField,
	TerminationDateField,
	TimeFromSelector,
	TimeToSelector
} from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields"
import { AppAntSwitch } from "@components"
import { useSignal } from "@preact/signals-react"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"

export default function ReportFormDrawerDateSection() {


	return <Grid container spacing={2}>
		<Grid item xs={12} data-tour-id="tour-pickup-dates">
			<PickupDatesSubSection/>
		</Grid>
		<Grid item xs={3} data-tour-id="tour-rental-length">
			<RentalLengthField/>
		</Grid>
		<Grid item xs={1} data-tour-id="tour-days-monitor">
			<DaysToMonitorField/>
		</Grid>
		<Grid item xs={1} data-tour-id="tour-pickup-time">
			<TimeFromSelector/>
		</Grid>
		<Grid item xs={1}>
			<TimeToSelector/>
		</Grid>
		<Grid item xs={12}>
			<MoreFeaturesSection/>
		</Grid>

	</Grid>
}

function MoreFeaturesSection() {

	const showFeatures = useSignal(!!reportFormData.peek().checkinWeekdayFilter?.length || !!reportFormData.peek().terminationDate?.length)


	return <Grid container spacing={2}>
		<Grid item xs={3}>
			{showFeatures.value && <CheckinWeekdayField/>}
		</Grid>
		<Grid item xs={2}>
			{showFeatures.value && <TerminationDateField/>}
		</Grid>
		<Grid item xs={2}>
			<AppAntSwitch
				trueText="More Features"
				checked={showFeatures.value}
				onChange={() => showFeatures.value = !showFeatures.value}
			/>
		</Grid>
	</Grid>
}